import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define proper types for drag data
export interface DragData {
  id: string;
  amount: number;
  type: string;
  date: string;
  transactionId: number;
  formattedAmount: string;
  originalColor: 'sky' | 'danger';
  isPositive: boolean;
  details: string;
  sourceAccountId?: string;
  index?: number;
}

interface DragContextType {
  currentDragData: DragData | null;
  setCurrentDragData: (data: DragData | null) => void;
}

const DragContext = createContext<DragContextType | undefined>(undefined);

export const useDragContext = (): DragContextType => {
  const context = useContext(DragContext);
  if (!context) {
    throw new Error('useDragContext must be used within a DragProvider');
  }
  return context;
};

interface DragProviderProps {
  children: ReactNode;
}

export const DragProvider: React.FC<DragProviderProps> = ({ children }) => {
  const [currentDragData, setCurrentDragData] = useState<DragData | null>(null);

  const value = {
    currentDragData,
    setCurrentDragData,
  };

  return (
    <DragContext.Provider value={value}>
      {children}
    </DragContext.Provider>
  );
};

export default DragContext;